import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, finalize, take } from 'rxjs';
import { BANNER_TYPE } from 'src/app/components/banner/banner.constants';
import { ShipperConfig } from 'src/app/core/models/sci/shipper-config.model';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { environment } from 'src/app/environments/environment';
import { ErrorhandleService } from '../../error-handling/error-handle/errorhandle.service';

@Injectable({
  providedIn: 'root',
})
export class ShipperConfigService {
  baseUrl = environment.apiUrl.concat('/shipperinfo/');

  constructor(
    private http: HttpClient,
    private commonUtils: CommonUtils,
    private errorHandler: ErrorhandleService,
  ) {}

  getShipperConfig(searchTxt: string, loginId: string | undefined) {
    this.commonUtils.updateLoadingModal(true);
    return this.http
      .get<
        ShipperConfig[]
      >(`${this.baseUrl}search/${loginId}${searchTxt ? '?searchText=' + searchTxt : ''}`)
      .pipe(
        take(1),
        catchError((error) =>
          this.errorHandler.handleError<any>(
            error,
            error.status,
            'Shipper Config Service: Get Shipper Config',
            BANNER_TYPE.SHIPPER_CONFIG_ERROR,
          ),
        ),
        finalize(() => {
          this.commonUtils.updateLoadingModal(false);
        }),
      );
  }

  deleteShipperConfig(shipperId: string) {
    this.commonUtils.updateLoadingModal(true);
    return this.http.delete(`${this.baseUrl}${shipperId}`).pipe(
      take(1),
      catchError((error) =>
        this.errorHandler.handleError<any>(
          error,
          error.status,
          'Shipper Config Service: Delete Shipper Config',
          BANNER_TYPE.SHIPPER_CONFIG_ERROR,
        ),
      ),
      finalize(() => {
        this.commonUtils.updateLoadingModal(false);
      }),
    );
  }

  addShipperConfig(loginId: string, payload: any) {
    this.commonUtils.updateLoadingModal(true);
    return this.http
      .post(`${this.baseUrl}saveshipperinfo/${loginId}`, payload)
      .pipe(
        take(1),
        catchError((error) =>
          this.errorHandler.handleError<any>(
            error,
            error.status,
            'Shipper Config Service: Post Shipper Config',
            BANNER_TYPE.SHIPPER_CONFIG_ERROR,
          ),
        ),
        finalize(() => {
          this.commonUtils.updateLoadingModal(false);
        }),
      );
  }
}
